import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError } from "../api/api";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";

import {
  getDashboardCardAction,
  getDashboardGraphDataAction,
  getFeedbackReportsAction,
  getFinancialReportsAction,
  getJobSummaryReportsAction,
  getLeadReportsAction,
  getReferrersReportsAction,
  setDashboardCardAction,
  setDashboardGraphDataAction,
  setFeedbackReportsAction,
  setFinancialReportsAction,
  setJobSummaryReportsAction,
  setLeadReportsAction,
  setReferrersReportsAction,
} from "../reducers/dashboardSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getDashboardGraphDataSaga(payload: any): any {
  console.log("payload data-", payload);
  const {
    source,
    startDateRange,
    endDateRange,
    interval,
    invoiceType,
    typeOfMove,
    refName,
    clientRefID,
    serviceName,
    fromStatus,
    toStatus,
    location,
    postCode,includeArchived
  } = payload?.payload;
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    // Build URL with only parameters that have values
    const baseUrl = `/client/dashboard/graphs?source=${source}&startDate=${startDateRange}&endDate=${endDateRange}&interval=${interval}&includeArchived=${includeArchived}`;

    let fullUrl = baseUrl;

    // Append optional parameters only if they exist
    if (invoiceType) fullUrl += `&invoiceType=${invoiceType}`;
    if (typeOfMove) fullUrl += `&typeOfMove=${typeOfMove}`;
    if (refName) fullUrl += `&refID=${refName}`;
    if (clientRefID) fullUrl += `&clientRefID=${clientRefID}`;
    if (fromStatus) fullUrl += `&fromStatus=${fromStatus}`;
    if (toStatus) fullUrl += `&toStatus=${toStatus}`;
    if (location) fullUrl += `&location=${location}`;
    if (serviceName) fullUrl += `&serviceName=${serviceName}`;
    if (postCode) fullUrl += `&postcode=${postCode}`;

    const temp = yield call<any>(callAPI, {}, "get", fullUrl);
    console.log("temp-", temp);
    if (temp?.data) {
      yield put(setDashboardGraphDataAction(temp?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getDashboardCardSaga(payload: any): any {
  console.log("payload data-", payload);
  const { startDateRange, endDateRange, excLeadStatus } = payload?.payload;
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const temp = yield call<any>(
      callAPI,
      {},
      "get",
      `/client/dashboard/stats?startDate=${startDateRange}&endDate=${endDateRange}&excLeadStatus=${excLeadStatus === true ? "ARCHIVED" : ""}`
    );
    console.log("temp-", temp);
    if (temp?.data) {
      yield put(setDashboardCardAction(temp?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getFinancialReportsSaga(payload: any): any {
  console.log("payload data-", payload);
  const { startDate, endDate } = payload?.payload;
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const temp = yield call<any>(
      callAPI,
      {},
      "get",
      `/client/reports/financials?startDate=${startDate}&endDate=${endDate} &excLeadStatus=ARCHIVED&excVatInvoices=true`
    );
    console.log("temp-", temp);
    if (temp?.data) {
      yield put(setFinancialReportsAction(temp?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getLeadReportsSaga(payload: any): any {
  console.log("payload data-", payload);
  const { startDate, endDate } = payload?.payload;
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const temp = yield call<any>(
      callAPI,
      {},
      "get",
      `/client/reports/leads?startDate=${startDate}&endDate=${endDate}&excLeadStatus=ARCHIVED`
    );
    console.log("temp-", temp);
    if (temp?.data) {
      yield put(setLeadReportsAction(temp?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getFeedbackReportsSaga(payload: any): any {
  console.log("payload data-", payload);
  const { startDate, endDate } = payload?.payload;
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const temp = yield call<any>(
      callAPI,
      {},
      "get",
      `/client/reports/feedback?startDate=${startDate}&endDate=${endDate}`
    );
    console.log("temp-", temp);
    if (temp?.data) {
      yield put(setFeedbackReportsAction(temp?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getJobSummaryReportsSaga(payload: any): any {
  console.log("payload data-", payload);
  const { startDate, endDate } = payload?.payload;
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const temp = yield call<any>(
      callAPI,
      {},
      "get",
      `/client/reports/jobs?startDate=${startDate}&endDate=${endDate}`
    );
    console.log("temp-", temp);
    if (temp?.data) {
      yield put(setJobSummaryReportsAction(temp?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getReferrersReportsSaga(payload: any): any {
  console.log("payload data-", payload);
  const { startDate, endDate } = payload?.payload;
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const temp = yield call<any>(
      callAPI,
      {},
      "get",
      `/client/reports/referrers?startDate=${startDate}&endDate=${endDate}`
    );
    console.log("temp-", temp);
    if (temp?.data) {
      yield put(setReferrersReportsAction(temp?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

export function* watchDashboard() {
  yield takeLatest<any>(getDashboardCardAction, getDashboardCardSaga);
  yield takeLatest<any>(getDashboardGraphDataAction, getDashboardGraphDataSaga);
  yield takeLatest<any>(getFinancialReportsAction, getFinancialReportsSaga);
  yield takeLatest<any>(getLeadReportsAction, getLeadReportsSaga);
  yield takeLatest<any>(getFeedbackReportsAction, getFeedbackReportsSaga);
  yield takeLatest<any>(getJobSummaryReportsAction, getJobSummaryReportsSaga);
  yield takeLatest<any>(getReferrersReportsAction, getReferrersReportsSaga);
}
